import { Pipe, PipeTransform } from '@angular/core';
import { CombinedFacets } from '../../facets/models/facet';

@Pipe({
  name: 'facetValues'
})
export class FacetValuesPipe implements PipeTransform {
  public transform(values: string[], facetcode: string, combinedFacets: CombinedFacets): string {
    if (values && values.length > 0 && combinedFacets && combinedFacets.facets[facetcode] && combinedFacets.facets[facetcode].length) {
      const facets = values.filter(value => value.startsWith(facetcode + '='))
      let facetValues = ''

      for (let foundFacet of facets) {
        const value = combinedFacets.facets[facetcode].find(facet => facet.code === foundFacet)

        if (value && value.name) {
          facetValues += value.name + ', '
        }
      }

      if (facetValues && facetValues.endsWith(', ')) {
        facetValues = facetValues.substr(0, facetValues.length - 2)

        return facetValues
      }
    }

    return ''
  }
}
